import { FORM_COL } from "../../../../../../../../constants";
import {
  ISearchTreePickerModel,
  ITreeDataItem
} from "../../../../../../../../core/forms/controls/searchTreePicker/ISearchTreePickerModel";
import { INIT_SEARCHTREEPICKER } from "../../../../../../../../core/forms/controls/searchTreePicker/SearchTreePicker_model";
import { generateFormFieldsFromJson } from "../../../../../../../../core/forms/helpers/FormFieldMappers";
import I18n from "../../../../../../../../core/localization/I18n";
import { UiActionRenderers } from "../../../../../../../../core/uiAction/IUiAction";

export const getImpactBusinessAreasSidebarFormActions = (updateImpactFn: () => void, canEdit: boolean, closeFn) => {
  let actions = [];

  if (canEdit)
    actions.push({
      id: "action1",
      label: I18n.t("phrases.done"),
      onAction: ev => {
        closeFn();
        updateImpactFn();
      },
      componentProps: {
        className: "ml-auto"
      },
      rendersIn: UiActionRenderers.BUTTON
    });

  return actions;
};

export const getImpactBusinessAreasSidebarFormFields = (busAreas: ITreeDataItem[]) => {
  const businessAreas: Partial<ISearchTreePickerModel> = {
    ...INIT_SEARCHTREEPICKER,
    key: "businessAreas",
    value: busAreas.filter(e => e.isChecked === true),
    options: busAreas,
    placeholder: I18n.t("placeholders.searchBusinessArea"),
    fieldClassName: FORM_COL.FULL_WIDTH
  };

  let fields = [];
  fields.push(businessAreas);

  return generateFormFieldsFromJson(fields);
};
